if (!customElements.get('selling-plan-widget')) {
  class SellingPlanWidget extends HTMLElement {
    constructor() {
      super();
      try {
        this.config = JSON.parse(this.querySelector('[data-spw-config]').textContent);
      } catch (e) {
        console.error('SellingPlanWidget: Failed to parse config JSON', e);
        return;
      }
      this.mode = this.config.mode;
      this.sectionId = this.config.sectionId;

      this.sellingPlanInput = document.getElementById('product-form-selling-plan');
      this.quantityInput = document.querySelector(`#Quantity-${this.sectionId}`);

      this.bindEvents();
      this.initState();
    }

    bindEvents() {
      // Purchase type toggle (subscription mode)
      this.querySelectorAll('.spw-option__radio').forEach((radio) => {
        radio.addEventListener('change', this.onPurchaseTypeChange.bind(this));
      });

      // Option card click (delegate to radio)
      this.querySelectorAll('.spw-option').forEach((option) => {
        option.addEventListener('click', this.onOptionClick.bind(this));
      });

      // Dropdown triggers
      this.querySelectorAll('.spw-dropdown__trigger').forEach((trigger) => {
        trigger.addEventListener('click', this.onDropdownToggle.bind(this));
      });

      // Dropdown items
      this.querySelectorAll('.spw-dropdown__item').forEach((item) => {
        item.addEventListener('click', this.onDropdownItemSelect.bind(this));
      });

      // Close dropdowns on outside click
      document.addEventListener('click', this.onDocumentClick.bind(this));

      // Listen for variant changes from the variant selector
      document.addEventListener('product:variant-change', this.onVariantChange.bind(this));
    }

  initState() {
    this.addToCartBtn = document.getElementById('AddToCart');
    this.addToCartBtnText = this.addToCartBtn ? this.addToCartBtn.querySelector('.single-add-to-cart-button--text') : null;
    this.variantInput = document.querySelector(`#product-form-${this.sectionId} input[name="id"]`);

    if (this.mode === 'subscription') {
      const isMobile = window.matchMedia('(max-width: 767px)').matches;

      if (isMobile) {
        // Mobile: default to one-time purchase
        const otpRadio = this.querySelector('.spw-option__radio[value="otp"], .spw-option__radio[value^="otp-"]');
        if (otpRadio) {
          otpRadio.checked = true;
          const otpOption = otpRadio.closest('.spw-option');
          this.querySelectorAll('.spw-option').forEach(opt => opt.classList.remove('spw-option--active'));
          if (otpOption) otpOption.classList.add('spw-option--active');
        }
        this.updateSellingPlan('');
        this.updateQuantity(1);

        // Pre-select OTP dropdown if present
        const otpDropdown = this.querySelector('[data-dropdown="otp"]');
        if (otpDropdown) {
          const preselected = otpDropdown.querySelector('.spw-dropdown__item--selected') ||
                              otpDropdown.querySelector('.spw-dropdown__item');
          if (preselected) {
            this.otpHasSelection = true;
            if (preselected.dataset.variantId) {
              this.updateVariantId(preselected.dataset.variantId);
            }
          } else {
            this.otpHasSelection = false;
          }
        } else {
          this.otpHasSelection = true; // No dropdown = no selection needed
        }

        this.toggleAddToCart(this.otpHasSelection);

      } else {
        // Desktop/tablet: default to subscription
        const firstPlanItem = this.querySelector('[data-dropdown="sub"] .spw-dropdown__item--selected') ||
                              this.querySelector('[data-dropdown="sub"] .spw-dropdown__item');
        if (firstPlanItem) {
          const planId = firstPlanItem.dataset.planId;
          this.updateSellingPlan(planId);
          this.updateQuantity(1);

          const variantId = firstPlanItem.dataset.variantId;
          if (variantId) {
            this.updateVariantId(variantId);
          }
        }
        this.toggleAddToCart(true);

        // Pre-select OTP dropdown variant in background (for when user switches to OTP)
        const otpDropdown = this.querySelector('[data-dropdown="otp"]');
        if (otpDropdown) {
          const preselected = otpDropdown.querySelector('.spw-dropdown__item--selected');
          this.otpHasSelection = !!preselected;
        }
      }

    } else if (this.mode === 'multi_otp') {
      this.updateSellingPlan('');
      this.updateQuantity(1);
    }
  }

    onOptionClick(e) {
      const option = e.target.closest('.spw-option');
      if (!option) return;

      // Don't interfere with dropdown interactions
      if (e.target.closest('.spw-dropdown') || e.target.closest('.spw-sub-info__link')) return;

      const radio = option.querySelector('.spw-option__radio');
      if (radio && !radio.checked) {
        radio.checked = true;
        radio.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    onPurchaseTypeChange(e) {
      const value = e.target.value;

      // Update active states
      this.querySelectorAll('.spw-option').forEach((opt) => {
        opt.classList.remove('spw-option--active');
      });
      const activeOption = e.target.closest('.spw-option');
      activeOption.classList.add('spw-option--active');

      if (this.mode === 'subscription') {
        if (value === 'otp' || value.startsWith('otp-')) {
          // One-time purchase selected
          this.updateSellingPlan('');
          this.updateQuantity(1);
          // Block add-to-cart if OTP has dropdown and no selection made yet
          const otpDropdown = this.querySelector('[data-dropdown="otp"]');
          if (otpDropdown && !this.otpHasSelection) {
            this.toggleAddToCart(false);
          } else {
            this.toggleAddToCart(true);
          }
        } else if (value === 'sub') {
          // Subscription selected - set first plan and its matching variant
          const firstPlanItem = this.querySelector('[data-dropdown="sub"] .spw-dropdown__item--selected') ||
                                this.querySelector('[data-dropdown="sub"] .spw-dropdown__item');
          if (firstPlanItem) {
            const planId = firstPlanItem.dataset.planId;
            this.updateSellingPlan(planId);
            this.updateQuantity(1);

            const variantId = firstPlanItem.dataset.variantId;
            if (variantId) {
              this.updateVariantId(variantId);
            }
          }
          this.toggleAddToCart(true);
        }
      } else if (this.mode === 'multi_otp') {
        // Multi-OTP: update quantity from selected option
        const quantity = parseInt(activeOption.dataset.quantity) || 1;
        this.updateSellingPlan('');
        this.updateQuantity(quantity);
      }
    }

    onDropdownToggle(e) {
      e.preventDefault();
      e.stopPropagation();

      const dropdown = e.target.closest('.spw-dropdown');
      const isOpen = dropdown.classList.contains('spw-dropdown--open');

      // Close all dropdowns first
      this.closeAllDropdowns();

      if (!isOpen) {
        dropdown.classList.add('spw-dropdown--open');
        dropdown.querySelector('.spw-dropdown__trigger').setAttribute('aria-expanded', 'true');
      }
    }

    onDropdownItemSelect(e) {
      e.preventDefault();
      e.stopPropagation();

      const item = e.target.closest('.spw-dropdown__item');
      if (!item) return;

      const dropdown = item.closest('.spw-dropdown');
      const dropdownType = dropdown.dataset.dropdown;

      // Update selected state
      dropdown.querySelectorAll('.spw-dropdown__item').forEach((i) => {
        i.classList.remove('spw-dropdown__item--selected');
      });
      item.classList.add('spw-dropdown__item--selected');

      // Update trigger text
      const titleEl = item.querySelector('.spw-dropdown__item-title');
      const triggerValue = dropdown.querySelector('.spw-dropdown__value');
      if (titleEl && triggerValue) {
        triggerValue.textContent = titleEl.textContent;
      }

      // Close dropdown
      this.closeAllDropdowns();

      if (dropdownType === 'otp') {
        const variantId = item.dataset.variantId;
        const quantity = item.dataset.quantity;

        if (variantId) {
          // Variant-based OTP selection
          this.updateVariantId(variantId);
          this.updateSellingPlan('');
          this.updateQuantity(1);

          // Update subscription prices for this variant
          const vid = String(variantId);
          if (this.config.variantAllocations && this.config.variantAllocations[vid]) {
            this.updateSubscriptionPrices(vid);
          }
        } else if (quantity) {
          // Bundle-based OTP selection (metafield quantity bundles)
          this.updateQuantity(parseInt(quantity) || 1);
          const planId = item.dataset.planId || '';
          if (planId) {
            this.updateSellingPlan(planId);
          } else {
            this.updateSellingPlan('');
          }
        }

        this.otpHasSelection = true;
        this.toggleAddToCart(true);

        // Update OTP header price with compare price
        const price = parseInt(item.dataset.price);
        const comparePrice = parseInt(item.dataset.comparePrice) || parseInt(item.dataset.originalPrice);
        if (price) {
          const otpPriceEl = this.querySelector('[data-otp-price]');
          if (otpPriceEl) {
            if (comparePrice && comparePrice > price) {
              otpPriceEl.innerHTML = `<span class="spw-price--original">${this.formatMoney(comparePrice)}</span> ${this.formatMoney(price)}`;
            } else {
              otpPriceEl.textContent = this.formatMoney(price);
            }
          }
        }
      } else if (dropdownType === 'sub') {
        // Subscription plan selected
        const planId = item.dataset.planId;
        this.updateSellingPlan(planId);
        this.updateQuantity(1);

        // Switch variant to match the selling plan
        const variantId = item.dataset.variantId;
        if (variantId) {
          this.updateVariantId(variantId);
        }

        // Update delivery info
        const delivery = item.dataset.delivery;
        const deliveryInfo = this.querySelector('[data-delivery-info]');
        if (deliveryInfo && delivery) {
          deliveryInfo.textContent = delivery;
        }

        // Update price display in header
        this.updateSubPriceDisplay(item);
      }
    }

    updateSubPriceDisplay(item) {
      const price = parseInt(item.dataset.price);
      const comparePrice = parseInt(item.dataset.comparePrice);

      const subPriceEl = this.querySelector('[data-sub-price]');
      if (subPriceEl && price) {
        subPriceEl.textContent = this.formatMoney(price);
      }

      const subOption = this.querySelector('[data-option="sub"]');
      if (!subOption) return;

      const originalPriceEl = subOption.querySelector('.spw-option__price .spw-price--original');
      if (originalPriceEl && comparePrice && comparePrice > price) {
        originalPriceEl.textContent = this.formatMoney(comparePrice);
        originalPriceEl.style.display = '';
      } else if (originalPriceEl) {
        originalPriceEl.style.display = 'none';
      }

      // Update badge
      if (comparePrice && comparePrice > price) {
        const discountPct = Math.round((comparePrice - price) / comparePrice * 100);
        const badge = subOption.querySelector('.spw-badge');
        if (badge) {
          const saveText = badge.textContent.replace(/\d+/, discountPct);
          badge.textContent = saveText;
        }
      }
    }

    onDocumentClick(e) {
      if (!e.target.closest('.spw-dropdown')) {
        this.closeAllDropdowns();
      }
    }

    closeAllDropdowns() {
      this.querySelectorAll('.spw-dropdown').forEach((dropdown) => {
        dropdown.classList.remove('spw-dropdown--open');
        dropdown.querySelector('.spw-dropdown__trigger').setAttribute('aria-expanded', 'false');
      });
    }

    onVariantChange(e) {
      if (!e.detail || !e.detail.variant) return;

      const variant = e.detail.variant;
      const newPrice = variant.price;

      // Update base price in OTP options
      this.config.basePrice = newPrice;
      this.config.currentVariantId = variant.id;

      // Update OTP header price
      const otpOption = this.querySelector('[data-option="otp"]');
      if (otpOption) {
        const priceEl = otpOption.querySelector('.spw-option__price');
        if (priceEl) {
          const hasFrom = priceEl.textContent.trim().toLowerCase().startsWith('fra');
          if (hasFrom) {
            priceEl.innerHTML = `Fra ${this.formatMoney(newPrice)}`;
          } else {
            priceEl.textContent = this.formatMoney(newPrice);
          }
        }
      }

      // Update subscription prices if we have allocation data
      const vid = String(variant.id);
      if (this.config.variantAllocations && this.config.variantAllocations[vid]) {
        this.updateSubscriptionPrices(vid);
      }

      // Update multi-OTP prices
      if (this.mode === 'multi_otp') {
        this.updateMultiOtpPrices(newPrice);
      }
    }

    updateSubscriptionPrices(variantId) {
      const allocations = this.config.variantAllocations[variantId];
      if (!allocations || allocations.length === 0) return;

      // Update subscription option header with first allocation
      const firstAlloc = allocations[0];
      const subOption = this.querySelector('[data-option="sub"]');
      if (subOption) {
        const priceEl = subOption.querySelector('[data-sub-price]');
        if (priceEl) {
          priceEl.textContent = this.formatMoney(firstAlloc.per_delivery_price);
        }

        const originalEl = subOption.querySelector('.spw-option__price .spw-price--original');
        if (originalEl) {
          if (firstAlloc.compare_at_price > firstAlloc.per_delivery_price) {
            originalEl.textContent = this.formatMoney(firstAlloc.compare_at_price);
            originalEl.style.display = '';
          } else {
            originalEl.style.display = 'none';
          }
        }

        // Update badge
        if (firstAlloc.compare_at_price > firstAlloc.per_delivery_price) {
          const pct = Math.round((firstAlloc.compare_at_price - firstAlloc.per_delivery_price) / firstAlloc.compare_at_price * 100);
          const badge = subOption.querySelector('.spw-badge');
          if (badge) {
            badge.textContent = badge.textContent.replace(/\d+/, pct);
          }
        }
      }

      // Update dropdown items
      const subDropdown = this.querySelector('[data-dropdown="sub"]');
      if (subDropdown) {
        const items = subDropdown.querySelectorAll('.spw-dropdown__item');
        items.forEach((item) => {
          const planId = parseInt(item.dataset.planId);
          const alloc = allocations.find((a) => a.selling_plan_id === planId);
          if (alloc) {
            item.dataset.price = alloc.per_delivery_price;
            item.dataset.comparePrice = alloc.compare_at_price;

            const priceEl = item.querySelector('.spw-dropdown__item-price');
            if (priceEl) priceEl.textContent = this.formatMoney(alloc.per_delivery_price);

            const origEl = item.querySelector('.spw-price--original');
            if (origEl) {
              if (alloc.compare_at_price > alloc.per_delivery_price) {
                origEl.textContent = this.formatMoney(alloc.compare_at_price);
                origEl.style.display = '';
              } else {
                origEl.style.display = 'none';
              }
            }
          }
        });
      }
    }

    updateMultiOtpPrices(basePrice) {
      // Update base option
      const baseOption = this.querySelector('[data-option="otp-0"]');
      if (baseOption) {
        baseOption.dataset.price = basePrice;
        const priceEl = baseOption.querySelector('.spw-option__price');
        if (priceEl) priceEl.textContent = this.formatMoney(basePrice);
      }
    }

    toggleAddToCart(enabled) {
      if (!this.addToCartBtn) return;
      if (enabled) {
        this.addToCartBtn.removeAttribute('disabled');
        this.addToCartBtn.classList.remove('spw-disabled');
        if (this.addToCartBtnText) {
          this.addToCartBtnText.textContent = window.theme.variantStrings.addToCart;
        }
      } else {
        this.addToCartBtn.setAttribute('disabled', 'disabled');
        this.addToCartBtn.classList.add('spw-disabled');
      }
    }

    findVariantForPlan(planId) {
      if (!this.config.variantAllocations) return null;
      for (const [vid, allocations] of Object.entries(this.config.variantAllocations)) {
        if (allocations.some(a => a.selling_plan_id === planId)) {
          return vid;
        }
      }
      return null;
    }

    updateVariantId(variantId) {
      if (this.variantInput) {
        this.variantInput.value = variantId;
        this.variantInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
    }

    updateSellingPlan(planId) {
      if (this.sellingPlanInput) {
        this.sellingPlanInput.value = planId || '';
      }
    }

    updateQuantity(qty) {
      if (this.quantityInput) {
        this.quantityInput.value = qty;
      }
    }

    formatMoney(cents) {
      const format = this.config.moneyFormat || '{{amount}} kr';
      const amount = (cents / 100).toFixed(2).replace('.', ',').replace(/,00$/, '');
      return format
        .replace('{{amount}}', amount)
        .replace('{{amount_no_decimals}}', Math.round(cents / 100))
        .replace('{{amount_with_comma_separator}}', amount)
        .replace('{{amount_no_decimals_with_comma_separator}}', Math.round(cents / 100))
        .replace('{{amount_with_apostrophe_separator}}', amount);
    }
  }

  customElements.define('selling-plan-widget', SellingPlanWidget);
}